module.exports = __webpack_public_path__ + "images/emoji/womens.32d5253709e5e7160ad6.png";